import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getImplementa = async (centroCosto, estado, fecha, codigoEquipo) => {
    try {
      const userInfo = fetchUser();

      const {data}  = await Axios.get(
        `/implementa?empresa=${userInfo.empresa}&estado=${estado}&centroCosto=${centroCosto}&fecha=${fecha}&codigoEquipo=${codigoEquipo}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearImplementa = async (clienteData) => {
    try {
      const userInfo = fetchUser();
      clienteData.empresa = userInfo.empresa;

        const {data}  = await Axios.post(
            '/implementa', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateImplementa = async (clienteData) => {
    try {
      const userInfo = fetchUser();
      clienteData.empresa = userInfo.empresa;
      
        const {data}  = await Axios.patch(
          `/implementa/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const updateImplementaSelect = async (clienteData) => {
    try {
      
        const {data}  = await Axios.patch(
          `/implementa/select/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };
  
  export const updateEstadoImplementa = async (clienteData) => {
    try {

        const {data}  = await Axios.patch(
          `/implementa/estado/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const updateImplementaAnular = async (idImplementa, payload) => {
    try {
      const { data } = await Axios.patch(
        `/implementa/anular/${idImplementa}`,
        payload
      );
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  export const deleteImplementa = (Id) => Axios.delete(`/implementa/${Id}`);